import React from 'react';
import {
  footerLinkClass,
  footerTaglineClass,
  primaryPageShellClass,
} from '../../tokens';

// V3 footer:
//   LEFT  — short tagline in mono uppercase
//   RIGHT — Writing / LinkedIn / GitHub / Email link set
//
// Link order goes from "this site's own writing" outward — internal
// writing, then professional profile, then technical profile, then direct
// contact.
//
// Footer: same horizontal inset as the header (`px-6 lg:px-12`, full width).

const FOOTER_LINKS = [
  { label: 'Writing', href: '#/Writing', external: false },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/shareef-jasim/', external: true },
  { label: 'GitHub', href: 'https://github.com/shareefjasim', external: true },
  { label: 'Email', href: 'mailto:shareefjasim1@gmail.com', external: false },
];

const Footer = () => {
  return (
    <footer className="shrink-0 bg-white dark:bg-black transition-colors duration-500">
      <div className={`${primaryPageShellClass} py-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6`}>
        <p className={footerTaglineClass}>
          Computational Designer&nbsp;&middot;&nbsp;Creative Technologist
        </p>

        <nav className="flex items-center gap-6 sm:gap-8">
          {FOOTER_LINKS.map(({ label, href, external }) => (
            <a
              key={label}
              href={href}
              target={external ? '_blank' : undefined}
              rel={external ? 'noopener noreferrer' : undefined}
              data-cursor="pointer"
              className={footerLinkClass}
            >
              {label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
